module.exports = __webpack_public_path__ + "static/media/SiteLinksExample@1x.64ce27b5745343f3353580bce10d6fd8.jpg";